import React from 'react';
import { Component, HBox, Position } from "puzzle";
import classNames from "classnames";
import _ from 'lodash';
import { DUE_DATE_INFOS, PROPS, STATE } from './Types';
import { getUnixDate, PuzzleButton } from "puzzle";
import DefaultSection from "./Section/Default/DefaultSection";
import TemplateSection from "./Section/Template/TemplateSection";
import { adjustPhaseDueDates } from "../../util/Util";


class MultiBatchUpload extends Component<STATE, PROPS> {
  protected dropUploadModulesData: any = [];
  protected sectionName: string = 'MultiBatchUpload_';
  protected isValid = false;
  protected filesData: any = [];
  protected workflowPhasesBatchesData: any = {};
  protected phasesDueDates: any = {};
  protected batchesSnapshot: any = [];

  static defaultProps = {
    dispatcherUpdateStates: {
      uploadFlowState: {}
    }
  };

  constructor(props: any) {
    super(props);
    const { batchInfos, deletedBatches = [], submissionDueDate } = this.props;
    this.state = {
      numberOfBatches: batchInfos.length >= 2 ? batchInfos.length : 1,
      batches: [],
      deletedBatches,
      simpleBatchData: {},
      simpleBatchFolder: '',
      submissionDueDate,
      createBatchPerLanguage: false,
      uploadFlowState: {}
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    const { uploadFlowState } = prevState;
    const { uploadFlowState: currentUploadFlowState } = this.state;

    if (!_.isEqual(currentUploadFlowState, uploadFlowState)) {

      const fileUploadInProgress = !this.isAllUploadEnd();
      if (this.isModuleMounted) {
        this.dispatch('updateBatchUploadDialog', {
          pos: Position.start,
          persistent: ['uploadIsInProgress']
        }, {
          uploadIsInProgress: fileUploadInProgress
        })
      }
    }
  }

  /**
   * Creates new multi batch section
   */
  addNewSection = (existingItemIndex?: number) => {
    const { numberOfBatches, batches } = this.state;
    let newBatchItems: any[] = [...batches];
    let moduleIds = batches.map((item: any) => item.moduleId);
    let newModuleId = this.sectionName + numberOfBatches;

    const newId = moduleIds.includes(newModuleId) ? this.createModuleId(batches[batches.length - 1]) : newModuleId;
    const newElement = {
      moduleId: newId,
      ...(_.isNumber(existingItemIndex) && {
        name: this.generateBatchName(batches),
        dueDate: batches[existingItemIndex].dueDate,
        targetLanguageInfos: _.cloneDeep(batches[existingItemIndex].targetLanguageInfos),
        workflowId: batches[existingItemIndex].workflowId
      })
    };

    let position = _.isNumber(existingItemIndex) ? ++existingItemIndex : newBatchItems.length;
    newBatchItems.splice(position, 0, newElement);

    if (_.isNumber(existingItemIndex)) {
      return newBatchItems;
    } else {
      this.setState({
        numberOfBatches: numberOfBatches + 1,
        batches: newBatchItems
      })
    }
  };

  /**
   * Adjust existing due dates to match new batch due date
   */
  adjustDueDates = (dueDatesInfo: DUE_DATE_INFOS[], batchDueDate: number) => {
    let i = 0;
    let dueDatesLength = dueDatesInfo.length;
    let currentDueDate;
    while (i < dueDatesLength) {
      currentDueDate = dueDatesInfo[i];
      if (currentDueDate.phasesDueDates) {
        currentDueDate = adjustPhaseDueDates(currentDueDate.phasesDueDates, batchDueDate);
      }
      i++;
    }

    return dueDatesInfo;
  }

  /**
   * Apply due dates to all batches
   */
  applyPhaseDueDatesToAllBatches = (phasesDueDates: any) => {
    this.phasesDueDates = phasesDueDates;
    let params;
    const { numberOfBatches, batches } = this.state;
    for (let i = 0; i < numberOfBatches; i++) {
      params = {
        moduleId: batches[i].moduleId,
        all: i === (numberOfBatches - 1)
      };
      this.dispatch('collectAllBatchesWorkflowPhases', Position.end, params);
    }
  };

  areThereUnsavedChanges = (filesChanged: boolean = false): boolean => !_.isEqual(this.batchesSnapshot, this.state.batches) || filesChanged;

  /**
   * Creates targetLanguagesInfo array
   */
  assembleTargetLanguageInfos = (targetLanguages: string[], date: any, dueDateInfos: any) => {
    const targetLanguageInfos = targetLanguages.map(this.mapTargetLanguages.bind(this, date, dueDateInfos));
    return targetLanguageInfos
  };

  /**
   * Change Batch data handler
   *
   * @param event
   * @param moduleId
   * @param operation
   */
  changeBatchData = (moduleId: string, operation: string, event: any) => {
    const { batches, submissionDueDate } = this.state;
    let editedBatches: any = [];
    let dueDateExceedsCurrent = undefined;
    if (operation) {
      editedBatches = this.executeOperation(operation, moduleId);
    } else {
      const { name } = event.target.props;
      let index = _.findIndex(batches, (item: any) => item.moduleId === moduleId);
      editedBatches = [...this.state.batches];
      let targetLanguage
      let dueDateInfos: any;
      switch (name) {
        case 'workflowId':
          targetLanguage = editedBatches[index].targetLanguageInfos;
          dueDateInfos = []; //reset phase due dates
          editedBatches[index] = {
            ...editedBatches[index],
            [name]: event.target.value,
            ...(targetLanguage && { targetLanguageInfos: this.assembleTargetLanguageInfos(targetLanguage, editedBatches[index].dueDate, dueDateInfos) })
          };
          break;
        case 'targetLanguage' :
          dueDateInfos = editedBatches[index].targetLanguageInfos?.map((item: any) => {
            return {
              phasesDueDates: item.dueDateInfos,
              targetLanguage: item.targetLanguage
            }
          }) || [];
          editedBatches[index] = {
            ...editedBatches[index],
            targetLanguageInfos: this.assembleTargetLanguageInfos(event.target.value, editedBatches[index].dueDate, dueDateInfos)
          };
          break;
        case 'dueDate' :
          targetLanguage = editedBatches[index].targetLanguageInfos;
          dueDateInfos = editedBatches[index].targetLanguageInfos?.map((item: any) => {
            return {
              phasesDueDates: item.dueDateInfos,
              targetLanguage: item.targetLanguage
            }
          }) || [];
          if (targetLanguage && targetLanguage[0]) {
            let oldDueDate = getUnixDate(targetLanguage[0].dueDate);
            let newDate = getUnixDate(event.target.value);
            if (oldDueDate > newDate) {
              dueDateInfos = this.adjustDueDates(dueDateInfos, newDate);
            }
          }
          editedBatches[index] = {
            ...editedBatches[index],
            [name]: event.target.value,
            ...(targetLanguage && { targetLanguageInfos: this.assembleTargetLanguageInfos(targetLanguage, event.target.value, dueDateInfos) })
          };
          dueDateExceedsCurrent = event.target.value > submissionDueDate ? event.target.value : undefined;
          break;
        case 'phaseDueDate':
          targetLanguage = editedBatches[index].targetLanguageInfos;
          dueDateInfos = editedBatches[index].targetLanguageInfos?.map((item: any) => {
            return {
              targetLanguage: item.targetLanguage,
              phasesDueDates: item.dueDateInfos
            }
          });
          let findDuplicateIndex = dueDateInfos.findIndex((item: any) => item.targetLanguage === event.target.value.targetLanguage);
          if (findDuplicateIndex === -1) {
            dueDateInfos = [...dueDateInfos, event.target.value];
          } else {
            dueDateInfos[findDuplicateIndex] = event.target.value;
          }
          editedBatches[index] = {
            ...editedBatches[index],
            ...(targetLanguage && { targetLanguageInfos: this.assembleTargetLanguageInfos(targetLanguage, editedBatches[index].dueDate, dueDateInfos) })
          }
          break;
        case 'phaseDueDateMultiple':
          targetLanguage = editedBatches[index].targetLanguageInfos;
          dueDateInfos = event.target.value;
          editedBatches[index] = {
            ...editedBatches[index],
            ...(targetLanguage && { targetLanguageInfos: this.assembleTargetLanguageInfos(targetLanguage, editedBatches[index].dueDate, dueDateInfos) })
          }
          break;
        case 'translationMemory':
          const { props, value } = event.target;
          const targetLangIndex = _.findIndex(editedBatches[index].targetLanguageInfos, { targetLanguage: props.targetLanguage });
          if (targetLangIndex >= 0) {
            const targetLanguageInfo = editedBatches[index].targetLanguageInfos[targetLangIndex];
            if (props.userChange) {
              if (targetLanguageInfo.tmProfileId) {
                if (value) {
                  targetLanguageInfo.tmOperation = 'UPDATED';
                } else {
                  targetLanguageInfo.tmOperation = 'DELETED';
                }
              } else if (value) {
                targetLanguageInfo.tmOperation = 'ADDED';
              }
            }
            targetLanguageInfo.tmProfileId = value;
          }
          break;
        default:
          editedBatches[index] = {
            ...editedBatches[index],
            [name]: event.target.value
          };
          break;
      }
    }
    this.setState({
      batches: editedBatches.updatedBatchList ? editedBatches.updatedBatchList : editedBatches,
      numberOfBatches: editedBatches.updatedBatchList ? editedBatches.updatedBatchList.length : editedBatches.length,
      ...(editedBatches.deletedBatches && { deletedBatches: editedBatches.deletedBatches }),
      ...(dueDateExceedsCurrent && { submissionDueDate: dueDateExceedsCurrent })
    })
  };

  /**
   * Change due dates to all batches
   */
  changeDueDatesToAllBatches = () => {
    let workflowPhasesData = this.workflowPhasesBatchesData;
    let newPhasesDueDates = this.phasesDueDates;
    const { numberOfBatches, batches } = this.state;
    let i = 0;
    let dueDateInfos: any = [];
    let currentTargetLanguage;
    let currentBatchPhases;
    let currentBatch;
    while (i < numberOfBatches) {
      currentBatch = batches[i];
      if (newPhasesDueDates.workflowId === currentBatch.workflowId) {
        dueDateInfos = currentBatch.targetLanguageInfos?.map((item: any) => {
          return {
            targetLanguage: item.targetLanguage,
            phasesDueDates: newPhasesDueDates.dueDates
          }
        });

        currentTargetLanguage = currentBatch.targetLanguageInfos;
        let lastPhaseDate = new Date(newPhasesDueDates.dueDates[newPhasesDueDates.dueDates.length - 1].dueDate);
        let batchDate = currentBatch.dueDate < lastPhaseDate ? lastPhaseDate : currentBatch.dueDate;
        batches[i] = {
          ...batches[i],
          dueDate: batchDate,
          ...(currentTargetLanguage && { targetLanguageInfos: this.assembleTargetLanguageInfos(currentTargetLanguage, batchDate, dueDateInfos) })
        }
      } else {
        // @ts-ignore
        currentBatchPhases = workflowPhasesData[currentBatch.moduleId];
        let newDueDates = newPhasesDueDates.dueDates;
        let newDueDatesLength = newDueDates.length;
        let findMatch;
        let currentPhase: any;
        let isThereMatch = false;
        while (newDueDatesLength) {
          newDueDatesLength--;
          currentPhase = newDueDates[newDueDatesLength];
          // eslint-disable-next-line no-loop-func
          findMatch = currentBatchPhases.phases.find((item: any) => item.phaseName === currentPhase.phaseName);
          if (findMatch) {
            isThereMatch = true;
            dueDateInfos = currentBatch.targetLanguageInfos?.map(this.mapCurrentBatchTargetInfos.bind(this, currentPhase));
          }
        }

        let lastPhaseDate = new Date(newDueDates[newDueDates.length - 1].dueDate);
        let batchDate = currentBatch.dueDate < lastPhaseDate ? lastPhaseDate : currentBatch.dueDate;
        if (isThereMatch) {
          currentTargetLanguage = currentBatch.targetLanguageInfos;
          batches[i] = {
            ...batches[i],
            dueDate: batchDate,
            ...(currentTargetLanguage && { targetLanguageInfos: this.assembleTargetLanguageInfos(currentTargetLanguage, batchDate, dueDateInfos) })
          }
        } else {
          batches[i] = {
            ...batches[i],
            dueDate: batchDate
          }
        }

      }
      i++;
    }
    this.setState({
      batches
    });

    this.workflowPhasesBatchesData = {};
    this.phasesDueDates = {};
  };

  /**
   * Returns all tickets that have no duplicates in other batches
   * @param filesForRemoval
   */
  checkForDuplicates = (filesForRemoval: any) => {
    let uniqueItems = filesForRemoval.tickets.filter((val: any) => !this.filesData.includes(val));
    this.filesData = [];
    return {
      tickets: uniqueItems
    };
  };

  /**
   * Check if it is TemplateCreatePage or TemplateEditPage.
   */
  checkIsTemplate = () => {
    const isTemplate = this.props.submissionMode === 'TEMPLATE_CREATE' || this.props.submissionMode === 'TEMPLATE_EDIT';
    return isTemplate
  }


  /**
   * Stores received sourceFiles data
   * @param data
   */
  collectFilesData = (data: any) => {
    let repositoryTickets = data.map((item: any) => item.repositoryTicket);
    this.filesData = [...new Set([...this.filesData, ...repositoryTickets])];
  };

  /**
   * After creating batchElements copy's files form the first batch to all of the batches
   */
  copyFilesToAllBatches = () => {
    if (this.props.submissionMode !== 'TEMPLATE_CREATE') {
      let obj;
      const { numberOfBatches, batches } = this.state;
      for (let i = 1; i < numberOfBatches; i++) {
        obj = {
          sourceModuleId: batches[0].moduleId,
          moduleId: batches[i].moduleId
        };
        this.dispatch('copyFilesToAllBatches', Position.end, obj);
      }
    }
  };

  /**
   * Creates values object used in Batch Sections for displaying data
   * @param batchItem
   */
  createConfigObj = (batchItem: any) => {
    const { name, workflowId, targetLanguageInfos = undefined, dueDate, moduleId } = batchItem;
    const { batches } = this.state;

    const otherBatchNames = batches.reduce((array: string[], item: any) => {
      return (item.name && item.moduleId !== moduleId) ? [...array, item.name] : array;
    }, []);

    return {
      values: {
        dueDate,
        name,
        otherBatchNames,
        targetLanguage: targetLanguageInfos?.map((item: any) => item.targetLanguage),
        targetLanguageInfos,
        workflowId
      }
    };
  };

  /**
   * Removes received files form batch targets.
   * @param removedFiles
   * @param moduleId
   */
  removeTargets = (removedFiles: any[], moduleId: string) => {
    let batchIndex = this.state.batches.findIndex((item: any) => {
      return item.moduleId === moduleId
    });

    let editedBatch = [...this.state.batches];
    editedBatch[batchIndex] = {
      ...editedBatch[batchIndex],
      targets: editedBatch[batchIndex].targets?.filter((item: any) => {
        return !removedFiles.some((value: any) => {
          return item.documentId === value.documentId
        })
      })
    };

    this.setState({
      batches: editedBatch
    })
  };

  /**
   * Creates new moduleId
   * @param module
   */
  createModuleId = (module: any) => {
    const { moduleId } = module;
    const id = parseInt(moduleId.split('_')[1]) + 1;
    return this.sectionName + id;
  };

  /**
   * Create batch per language button render
   */
  batchPerLanguageRender = () => {
    const { batches, createBatchPerLanguage } = this.state;
    let item = null;

    const buttonIconCls = classNames(
      'tp-icon tp-checkbox-outline', {
        'tp-checked-checkbox-outline': createBatchPerLanguage
      }
    );

    if (!['EDIT', 'TEMPLATE_EDIT'].includes(this.props.submissionMode)) {
      let buttonDisabledFlag = !(!createBatchPerLanguage && batches?.length <= 2 && batches[0]?.targetLanguageInfos?.length > 1);
      item = <PuzzleButton
        themeColor={'primary'}
        disabled={buttonDisabledFlag}
        className="tp-create-batch-per-language-btn"
        iconClass={buttonIconCls}
        onClick={this.createBatchPerLanguageHandler}>
        {this.translate('batchPerLanguage')}
      </PuzzleButton>
    }

    return item;
  };

  /**
   * Returns filtered batch object if items moduleId is different from passed moduleId.
   * @param moduleId
   * @param array
   * @param item
   */
  filterBatches = (moduleId: string, array: any, item: any) => {
    if (item.moduleId !== moduleId) {
      array.push(_.pick(item, ['moduleId', 'name']));
    }
    return array;
  };

  /**
   * In regard to received operation performs copy,clear, or delete routine.
   * @param operation
   * @param moduleId
   */
  executeOperation = (operation: string, moduleId: string) => {
    let updatedBatchList: any = [...this.state.batches];
    let index = _.findIndex(updatedBatchList, (item: any) => item.moduleId === moduleId);
    let deletedBatches = [...this.state.deletedBatches];

    if (operation === 'clear') {
      updatedBatchList[index] = {
        ...updatedBatchList[index],
        dueDate: null,
        name: "",
        targetLanguageInfos: [],
        workflowId: null
      }
    } else if (operation === 'copy') {
      updatedBatchList = this.addNewSection(index);
    } else if (operation === 'delete') {
      let removedItem = updatedBatchList.splice(index, 1);
      deletedBatches = removedItem[0]?.batchId ? [...deletedBatches, removedItem[0]] : deletedBatches;
    }

    return {
      updatedBatchList,
      deletedBatches
    };
  };

  /**
   * Returns highest index within default batch names.
   * @param previousResult
   * @param item
   */
  isDefaultBatchName = (previousResult: number, item: any) => {
    const reg = '^' + this.translate('defaultBatchName') + '[0-9]*$';
    const regexp = new RegExp(reg);
    let result = previousResult;

    if (regexp.test(item.name)) {
      let extractedNum = item.name.split(this.translate('defaultBatchName'));
      result = Math.max(parseInt(extractedNum[1]), previousResult);
    }
    return result
  };

  /**
   * Generate name on batch section copy
   * @param batches
   */
  generateBatchName = (batches: any) => {
    let maxIndex = batches.reduce(this.isDefaultBatchName, 0) + 1;
    return this.translate('defaultBatchName') + maxIndex;
  };

  /**
   * Send's dispatcher request for every module form the modules array
   * @param modules
   */
  getAllBatchesFilesData = (modules: string[]) => {
    this.filesData = [];
    for (let i = 0; i < modules.length; i++) {
      this.dispatch('collectModuleFiles', Position.end, {
        moduleId: modules[i],
        lastRequest: i === modules.length - 1
      });
    }
  };

  /**
   * Returns all moduleId's except the received one
   * @param moduleId
   */
  getOtherModuleIds = (moduleId: string) => {
    let modules = this.state.batches.filter((item: any) => item.moduleId !== moduleId).map((item: any) => item.moduleId);
    return modules;
  };

  /**
   * Map method for current batch target infos data
   */
  mapCurrentBatchTargetInfos = (currentPhase: any, item: any) => {
    let findDuplicateIndex = item.dueDateInfos.findIndex((item: any) => item.phaseName === currentPhase.phaseName);
    let phasesDueDates = item.dueDateInfos;
    if (findDuplicateIndex === -1) {
      phasesDueDates = [...phasesDueDates, currentPhase];
    } else {
      phasesDueDates[findDuplicateIndex] = currentPhase;
    }
    return {
      targetLanguage: item.targetLanguage,
      phasesDueDates: phasesDueDates
    }
  }

  /**
   * Maps targetLanguages to proper form
   */
  mapTargetLanguages = (dueDate: any, dueDateInfos: any[], targetLanguageInfo: any) => {
    let findDueDate;
    if (dueDateInfos.length) {
      findDueDate = dueDateInfos.find((item: any) => item?.targetLanguage === (targetLanguageInfo?.targetLanguage || targetLanguageInfo));
    }
    return {
      dueDate,
      targetLanguage: targetLanguageInfo?.targetLanguage || targetLanguageInfo,
      tmProfileId: targetLanguageInfo?.tmProfileId || null,
      dueDateInfos: findDueDate?.phasesDueDates || [],
      totalWordCount: 0
    }
  };

  /**
   * Sets data in MultiBatchUpload
   * @param batchInfos
   * @param simpleBatchData
   * @param folder
   */
  setData = (batchInfos: any, simpleBatchData: any, folder: string) => {
    if (_.isEmpty(simpleBatchData)) {
      const updatedBatch = this.updateBatchDates(batchInfos);
      this.batchesSnapshot = updatedBatch;
      this.setState({
        batches: updatedBatch,
      }, () => this.setExistingData());
    } else {
      const {
        targetLanguage,
        specificDate,
        workflow,
        uploadedFiles,
        deletedFiles,
        targetFormat,
        batchId,
        phasesDueDate,
        targetLanguageInfos
      } = simpleBatchData;
      let dueDateInfos = phasesDueDate?.map((item: any) => {
        return {
          targetLanguage: item.targetLanguage,
          phasesDueDates: item.dueDateInfos
        }
      }) || [];
      delete simpleBatchData.targetLanguage;
      delete simpleBatchData.specificDate;

      let dueDate = simpleBatchData.dueDate ? new Date(simpleBatchData.dueDate) : specificDate;
      let targetLanguageForAssemble = this.props.submissionMode === 'CLONE' ? targetLanguage : targetLanguageInfos || targetLanguage;
      let initialBatchData = [{
        ...(dueDate && { dueDate: dueDate }),
        moduleId: this.sectionName + 0,
        name: batchInfos[0]?.name || this.translate('defaultBatchName') + 1,
        submissionFolder: folder,
        ...(workflow && { workflowId: workflow }),
        ...(targetLanguage.length && { targetLanguageInfos: this.assembleTargetLanguageInfos(targetLanguageForAssemble, dueDate, dueDateInfos) }),
        uploadedFiles,
        deletedFiles,
        targetFormat,
        batchId
      }];

      this.batchesSnapshot = initialBatchData;
      this.setState({
        batches: initialBatchData,
      }, () => this.setNewData(folder));
    }
  };

  /**
   * Populates dropDown modules with saved data, and also populates sections with files.
   */
  setExistingData = () => {
    this.state.batches.forEach((item: any) => {
      let {
        deletedFiles = [],
        moduleId,
        submissionFolder,
        targets = [],
        uploadedFiles = []
      } = item;
      if (targets?.length > 0 && !uploadedFiles.length && !deletedFiles.length) {
        this.dispatch('setExistingFiles', Position.end, {
          targets,
          details: { project: this.props.project },
          moduleId
        });
      } else {
        uploadedFiles = uploadedFiles.map((item: any) => {
          item.isAlreadyUpload = true;
          return item;
        })
        this.dispatch('updateState', Position.end, {
          uploadedFiles,
          submissionFolder,
          moduleId
        });
      }
    });

  };

  /**
   * Populates first dropDown module with simple batch data.
   * @param folder
   */
  setNewData = (folder: string) => {
    let { uploadedFiles, moduleId } = this.state.batches[0];
    uploadedFiles = uploadedFiles.map((item: any) => {
      item.isAlreadyUpload = true;
      return item;
    })
    this.dispatch('updateState', Position.end, {
      uploadedFiles,
      submissionFolder: folder,
      moduleId
    });
  };

  /**
   *
   * Stores collect's validation values for all sections
   * @param validation
   * @param all
   */
  storeValidationData = (validation: boolean, all: boolean) => {
    this.isValid = this.isValid && validation;

    return all ? this.isValid : false
  };

  /**
   * Store workflow data
   */
  storeWorkflowPhasesData = (workflowData: any, moduleId: string) => {
    this.workflowPhasesBatchesData[moduleId] = workflowData;
  };

  /**
   * Used to convert dates batch object to unix date or to standard js date format.
   * @param batches
   * @param asUnixFormat
   */
  updateBatchDates = (batches: any, asUnixFormat?: boolean) => {
    const updatedBatch = batches.map((batch: any) => {
      let date = batch.targetLanguageInfos?.length && batch.targetLanguageInfos[0]?.dueDate;
      return {
        ...batch,
        ...(date && { dueDate: asUnixFormat ? getUnixDate(batch.targetLanguageInfos[0]?.dueDate) : new Date(batch.targetLanguageInfos[0]?.dueDate) }),
        targetLanguageInfos: batch.targetLanguageInfos?.map((languageInfo: any) => {
          let langDueDate = languageInfo.dueDate;
          let setDueDate = null;
          if (langDueDate) {
            setDueDate = asUnixFormat ? getUnixDate(langDueDate) : new Date(langDueDate);
          }
          return {
            ...languageInfo,
            dueDate: setDueDate
          }
        })
      }
    });
    return updatedBatch;
  };

  /**
   * Render for multi batch sections
   */
  renderBatches = () => {
    const { numberOfBatches, batches, submissionDueDate, uploadFlowState } = this.state;
    const { partiallyAnalyzed, submissionStarted } = this.props;
    let batchList = [];
    const length = numberOfBatches;
    for (let i = 0; i < length; i++) {
      const moduleId = batches[i]?.moduleId || this.sectionName + i;
      const filteredProps = _.omit(this.props, ['batches', 'submissionDueDate']);
      const targets = batches.reduce(this.filterBatches.bind(this, moduleId), []);
      const item = _.find(batches, (item: any) => item.moduleId === moduleId);
      if (item) {
        item.wordCount = this.props.batchInfos[i]?.wordCount;
      }
      let config = {
        batch: item,
        ...filteredProps,
        partiallyAnalyzed,
        submissionDueDate,
        key: 'section' + moduleId,
        isClosable: batches.length > 1 && !submissionStarted,
        moduleId: moduleId,
        moveToTargets: targets,
        multipleBatches: batches.length > 1,
        onChange: this.changeBatchData,
        uploadFlowState,
        submissionId: this.props.submissionId
      };

      Object.assign(config, item && (Object.keys(item).length > 1) ? this.createConfigObj(item) : null);

      let sectionComponent = ['TEMPLATE_CREATE', 'TEMPLATE_EDIT'].includes(filteredProps.submissionMode) ?
        <TemplateSection {...config} /> : <DefaultSection{...config} />;

      batchList.push(
        sectionComponent
      )
    }
    return batchList;
  };

  /**
   * Store's data of every DropUpload module until, all flag is received. Then goes through all stored data and merges it with batchesData
   * data is used on save action.
   */
  storeData = (moduleData: any, module: string, all: boolean) => {
    this.dropUploadModulesData.push({
      moduleId: module,
      moduleData: this.checkIsTemplate() ? [] : moduleData
    });

    let batchInfos: any = undefined;
    if (all) {
      let { batches, deletedBatches, submissionDueDate } = this.state;
      batches = this.updateBatchDates(batches, true);
      batchInfos = batches.map((item: any, index: number) => {
        let moduleData = _.find(this.dropUploadModulesData, (element) => element.moduleId === item.moduleId)?.moduleData;
        return {
          ...item,
          moduleId: this.sectionName + index,
          uploadedFiles: moduleData.droppedFiles,
          deletedFiles: moduleData.deletedFiles,
          submissionFolder: moduleData.submissionFolder,
          fileCount: moduleData.droppedFiles?.length
        };
      });

      batchInfos = {
        batchInfos,
        deletedBatches,
        ...(submissionDueDate > this.props.submissionDueDate && { submissionDueDate })
      }
    }
    return batchInfos
  };

  /**
   * Save button handler, gather's data form all DropUpload( all: true is sent when collectBatchesData called for every DropUpload)
   */
  saveBatches = () => {
    this.isValid = true;
    let obj;
    const { numberOfBatches, batches } = this.state;
    for (let i = 0; i < numberOfBatches; i++) {
      obj = {
        //@ts-ignore
        moduleId: batches[i].moduleId,
        isTemplate: this.checkIsTemplate()
      };
      Object.assign(obj, (i === (numberOfBatches - 1)) ? { all: true } : null);
      this.dispatch('collectData', Position.end, obj);
    }
  };

  /**
   * Scroll to selected batch
   */
  scrollToEl = (focusTarget: string) => {
    // push the execution to the end of a call stack allowing elements to get rendered
    setTimeout(this.scrollToElTimeout.bind(this, focusTarget), 0);
  };

  /**
   * After a delay scroll's selected batch in view
   */
  scrollToElTimeout = (focusTarget: string) => {
    const element = document.querySelector(`.${focusTarget}`);
    if (element) {
      element.scrollIntoView({
        behavior: "auto",
        block: "center",
        inline: "nearest"
      });

      let inputElement = element.querySelector('input');
      if (inputElement) {
        inputElement.focus();
      }
    }
  };

  /**
   * Creates batch for every language selected whit in first batch
   */
  createBatchPerLanguageHandler = () => {
    const { batches } = this.state;
    let batchPerLanguage = batches[0].targetLanguageInfos.map((item: any, index: number) => {
      const name = this.props.targetLanguageData.find((languageObject: any) => languageObject.targetLanguage === item.targetLanguage).targetLanguageDisplayName;
      this.dispatch('closeExtra', '', { moduleId: this.sectionName + index });
      if (index === 0) {
        return {
          ...batches[0],
          name,
          targetLanguageInfos: [batches[0].targetLanguageInfos[0]],
        };
      } else {
        return {
          name,
          targetLanguageInfos: [batches[0].targetLanguageInfos[index]],
          moduleId: this.sectionName + index,
          dueDate: batches[0].dueDate,
          workflowId: batches[0].workflowId,
          wordCount: 0
        };
      }
    });

    this.setState({
      createBatchPerLanguage: true,
      batches: batchPerLanguage,
      numberOfBatches: batchPerLanguage.length
    }, this.copyFilesToAllBatches);
  };

  renderBody(): any {
    const { submissionStarted } = this.props;

    return (
      <div>
        {this.batchPerLanguageRender()}
        {this.renderBatches()}
        <HBox
          justifyContentCenter
          className={'tp-add-more-batches-wrap'}>
          <PuzzleButton
            themeColor={'primary'}
            className={'tp-add-more-batches'}
            disabled={submissionStarted}
            iconClass={'tp-icon tp-add'}
            onClick={this.addNewSection.bind(this, undefined)}
          >
            {this.translate('addBatch')}
          </PuzzleButton>
        </HBox>
      </div>
    )
  }
}

export default MultiBatchUpload;
